import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles';
import { useMemo } from 'react';
import { COLUMN_MODE_PANEL_HEIGHT_PERCENT, ROW_MODE_PANEL_WIDTH_PERCENT } from '../../../constants/constants';
import { useIsRowLayoutMode } from '../../../hooks/useIsRowLayoutMode';
import { PanelRouter } from '../../../panels/panelRouter';
import { useAppSelector } from '../../../redux/store';
import { lightTheme } from '../../../styles/materialTheme';
export const PokerPanelContainer = () => {
    const activePanelType = useAppSelector((state) => state.panels.activePanelType);
    const stageDimensionsH = useAppSelector((state) => state.gameDimensions.stageDimensions?.h);
    const isRowLayoutMode = useIsRowLayoutMode();
    const containerCss = useMemo(() => {
        if (stageDimensionsH === undefined) {
            return;
        }
        return css(css `
        display: flex;
        flex-direction: column;
        position: absolute;
      `, isRowLayoutMode
            ? css `
            width: ${ROW_MODE_PANEL_WIDTH_PERCENT}%;
            height: ${stageDimensionsH}px;
            top: 0;
            right: 0;
          `
            : css `
            width: 100%;
            height: ${COLUMN_MODE_PANEL_HEIGHT_PERCENT}%;
            top: 0;
            left: 0;
          `);
    }, [isRowLayoutMode, stageDimensionsH]);
    if (!activePanelType || !containerCss) {
        return null;
    }
    return (_jsx("div", { css: containerCss, children: _jsx(StyledEngineProvider, { injectFirst: true, children: _jsx(ThemeProvider, { theme: lightTheme, children: _jsx(PanelRouter, {}) }) }) }));
};
